import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VProgressLinear,{staticClass:"ma-0",staticStyle:{"top":"-2px"},attrs:{"active":_vm.loading,"color":_vm.color,"indeterminate":true,"height":"4"}},[_vm._v("Loading...")])
}
var staticRenderFns = []

export { render, staticRenderFns }